import {Component, EventEmitter, HostListener, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {SearchBoxResponseModel} from '../../model/view/SearchBoxResponseModel';
import {debounceTime, filter, switchMap, tap} from 'rxjs/operators';
import {UtilsEngi} from '../tools/UtilsEngi';
import {SearchBoxService} from '../../services/search-box.service';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';

declare var window: any;

@ComponentAsElement('v-mini-search-box-element')
@Component({
  selector: 'v-mini-search-box',
  templateUrl: './mini-search-box.component.html',
  styleUrls: []
})
export class MiniSearchBoxComponent implements OnInit {
  constructor(
    private searchBoxService: SearchBoxService
  ) {
    this.showSearchBox = true;
    this.updateUrlToAllResult("");
  }

  readonly WAIT_TIME_BEFORE_REQUEST = window.SEARCH_BOX && window.SEARCH_BOX.WAIT_TIME_BEFORE_REQUEST || 500;
  readonly MIN_CHARACTERS_BEFORE_REQUEST = window.SEARCH_BOX && window.SEARCH_BOX.MIN_CHARACTERS_BEFORE_REQUEST || 3;
  readonly URL_TO_ALL_RESULT_PREFIX = '/szukaj?text=';

  public searchBoxResponseObs: Observable<SearchBoxResponseModel>;
  public showLoader = false;
  public showSearchResult = true;
  public showSearchBox = false;
  public urlToAllResult = '';

  private searchInputStreamObs = new EventEmitter<SearchInputValueEmit>();
  private searchInputStreamLastValue: SearchInputValueEmit = new SearchInputValueEmit('', false);

  ngOnInit() {
    this.searchBoxResponseObs = this.searchInputStreamObs.pipe(
      tap((_value) => {
        this.updateUrlToAllResult(_value.value);

        this.searchInputStreamLastValue = _value;
        this.showSearchResult = !!UtilsEngi.hasMinimumCharacters(_value.value, this.MIN_CHARACTERS_BEFORE_REQUEST);
      }),
      debounceTime(this.WAIT_TIME_BEFORE_REQUEST),
      filter((_value) => {
        return _value.force
          || UtilsEngi.hasMinimumCharacters(_value.value, this.MIN_CHARACTERS_BEFORE_REQUEST);
      }),
      tap(() => this.showLoader = true),
      switchMap(_value => this.getSearchBoxResult(_value.value, '')),
      tap(() => {
        this.showSearchResult = true;
        this.showLoader = false;
      })
    );
  }

  @HostListener('searchboxtoggle')
  public toggleSearchBox(): void {
    this.showSearchBox = !this.showSearchBox;
  }

  // @HostListener('searchboxclear')
  // public clearSearchBox(): void {
  //   this.clearInputFieldHandler();
  // }

  public startSearching() {
    window.location.href = this.urlToAllResult;
  }

  public inputSearchOnChange(_$event): void {
    this.searchInputStreamObs.emit(
      new SearchInputValueEmit(
        _$event,
        undefined
      )
    );
  }

  private updateUrlToAllResult(_searchValue: string = '') {
    this.urlToAllResult = this.URL_TO_ALL_RESULT_PREFIX + encodeURIComponent(_searchValue)
  }

  private getSearchBoxResult(
    _searchValue: string,
    _token: string
  ): Observable<SearchBoxResponseModel> {
    return this.searchBoxService.getSearchBoxResult(_searchValue, _token);
  }
}


class SearchInputValueEmit {
  public value: string = null;
  public force = false;

  constructor(
    _value: string,
    _force: boolean = false
  ) {
    this.value = _value;
    this.force = _force;
  }

}
